import { render, staticRenderFns } from "./CompanyEventModal.vue?vue&type=template&id=196c7248&scoped=true"
import script from "./CompanyEventModal.vue?vue&type=script&lang=js"
export * from "./CompanyEventModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyEventModal.vue?vue&type=style&index=0&id=196c7248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196c7248",
  null
  
)

export default component.exports